import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import StorySidePanel from './SidePanel';
import { Children, cloneElement, useEffect, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Story = function Story(_ref) {
  var className = _ref.className,
      children = _ref.children,
      panelLayout = _ref.panelLayout,
      theme = _ref.theme,
      activeStep = _ref.activeStep,
      onStepChange = _ref.onStepChange;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeSection = _useState2[0],
      setActiveSection = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      jumpSection = _useState4[0],
      setJumpSection = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      sidePanelRef = _useState6[0],
      setSidePanelRef = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      contentSize = _useState8[0],
      setContentSize = _useState8[1];

  var classes = classnames('ptr-Story', {}, 'is-' + panelLayout + '-layout', className);
  useEffect(function () {
    if (onStepChange) {
      onStepChange(activeSection);
    }
  }, [activeSection]);

  var onScroll = function onScroll(event) {
    var sidePanelNodes = Array.from(sidePanelRef.current.childNodes);
    var userReachedBottom = sidePanelRef.current.offsetHeight + sidePanelRef.current.scrollTop >= sidePanelRef.current.scrollHeight - 10;
    sidePanelNodes.forEach(function (node, index) {
      var userReachedSection = node.offsetTop - 100 <= event.target.scrollTop && node.offsetTop + node.offsetHeight - 100 > event.target.scrollTop;

      if (userReachedSection) {
        // user is located in this section (node)
        if (jumpSection === null) {
          // user is scrolling
          if (userReachedBottom) {
            setActiveSection(sidePanelNodes.length - 1);
          } else {
            setActiveSection(index);
          }
        } else {
          // user used navigation
          setActiveSection(jumpSection);
          var userJumpedToBottom = jumpSection === sidePanelNodes.length - 1;
          var userReachedJumpedSection = sidePanelNodes[jumpSection].offsetTop > event.target.scrollTop - 5 && sidePanelNodes[jumpSection].offsetTop < event.target.scrollTop + 5;

          if (userReachedBottom && userJumpedToBottom) {
            setJumpSection(null);
          } else if (userReachedJumpedSection) {
            setJumpSection(null);
          }
        }
      }
    });
  };

  var noSidePanel = !Children.map(children, function (child) {
    return child.type === StorySidePanel;
  }).includes(true);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [Children.map(children, function (child) {
      return child.type === StorySidePanel ? /*#__PURE__*/cloneElement(child, {
        onScroll: onScroll,
        setSidePanelRef: setSidePanelRef,
        panelLayout: panelLayout,
        theme: theme,
        activeSection: activeSection,
        activeStep: activeStep,
        setJumpSection: setJumpSection,
        contentSize: contentSize
      }) : sidePanelRef !== undefined || noSidePanel ? /*#__PURE__*/cloneElement(child, {
        activeSection: activeSection,
        setJumpSection: setJumpSection,
        sidePanelRef: sidePanelRef,
        panelLayout: panelLayout,
        theme: theme,
        noSidePanel: noSidePanel
      }) : null;
    }), /*#__PURE__*/_jsx(ReactResizeDetector, {
      onResize: function onResize(event) {
        return setContentSize(event);
      }
    })]
  });
};

Story.propTypes = {
  activeStep: PropTypes.number,
  onStepChange: PropTypes.func,
  defaultStep: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  panelLayout: PropTypes.string,
  theme: PropTypes.string
};
export default Story;